angular
  .module('contrast.factory.attack.event', [])
  .factory('AttackEventsFactory', function ($http, $q, UserService) {
    return {
      getNewEvents: function (filters) {
        var httpTimeout = $q.defer(),
          request = $http({
            method: 'post',
            url: UserService.buildAPIUrl('/rasp/events/new'),
            params: Object.assign(
              { expand: ['drilldownDetails', 'application_roles'] },
              filters.params
            ),
            data: filters.data,
            timeout: httpTimeout.promise
          })

        request._httpTimeout = httpTimeout
        return request
      },
      getNewLightEvents: function (filters) {
        var httpTimeout = $q.defer(),
          request = $http({
            method: 'post',
            url: UserService.buildAPIUrl('/protect/events'), // TODO - we can remove the expand field from the endpoint request in the BE since is never used
            params: filters.params,
            data: filters.data,
            timeout: httpTimeout.promise
          })

        request._httpTimeout = httpTimeout
        return request
      },

      getTimelineEvents: function (attackUuid) {
        return $http.get(UserService.buildAPIUrl('/rasp/events/timeline'), {
          params: { attackUuid: attackUuid }
        })
      },

      getEvent: function (eventUuid, expandValue) {
        return $http.get(
          UserService.buildAPIUrl('/rasp/events/summary/' + eventUuid),
          {
            params: { expand: expandValue || '' }
          }
        )
      },
      getEventNotes: function (eventUuid) {
        return $http.get(
          UserService.buildAPIUrl('/rasp/events/notes/' + eventUuid)
        )
      },
      addNote: function (eventUuid, note) {
        return $http.post(
          UserService.buildAPIUrl('/rasp/events/notes/' + eventUuid),
          { note: note }
        )
      },
      editNote: function (eventUuid, noteUuid, note) {
        return $http.put(
          UserService.buildAPIUrl(
            '/rasp/events/notes/' + eventUuid + '/' + noteUuid
          ),
          { note: note }
        )
      },
      deleteNote: function (eventUuid, noteUuid) {
        return $http['delete'](
          UserService.buildAPIUrl(
            '/rasp/events/notes/' + eventUuid + '/' + noteUuid
          )
        )
      },
      countUnreadEventNotes: function (eventUuid) {
        return $http.get(
          UserService.buildAPIUrl('/rasp/events/notes/' + eventUuid + '/unread')
        )
      },
      updateLastViewed: function (eventUuid) {
        return $http.put(
          UserService.buildAPIUrl('/rasp/events/notes/' + eventUuid + '/view')
        )
      },
      suppress: function (eventUuid, suppressSimilar) {
        return $http.put(
          UserService.buildAPIUrl('/rasp/events/' + eventUuid + '/suppress'),
          { suppress_similar: suppressSimilar || false }
        )
      },
      suppressBatch: function (events) {
        var self = this
        return self.batchExecution(events, self.suppress)
      },
      batchExecution: function (events, method) {
        var promises = []

        angular.forEach(events, function (event) {
          var defer = $q.defer()
          method(event.event_uuid).then(
            function (response) {
              defer.resolve({ success: true, response: response })
            },
            function (response) {
              defer.resolve({ success: false, response: response })
            }
          )
          promises.push(defer.promise)
        })

        return $q.all(promises)
      },
      getFiltersCatalogs: function () {
        return $http.get(UserService.buildAPIUrl('/rasp/events/filters'))
      },
      getFiltersByType: function (type, filters) {
        var httpTimeout = $q.defer(),
          request = $http({
            method: 'post',
            url: UserService.buildAPIUrl(
              '/rasp/events/filter/' + type + '/listing'
            ),
            data: filters,
            timeout: httpTimeout.promise
          })

        request._httpTimeout = httpTimeout
        return request
      },
      getEventsQuickFilters: function (filters) {
        var httpTimeout = $q.defer(),
          request = $http({
            method: 'post',
            url: UserService.buildAPIUrl('/rasp/events/filters/quick'),
            data: filters,
            timeout: httpTimeout.promise
          })

        request._httpTimeout = httpTimeout
        return request
      }
    }
  })
